export const MERCHANT_ADMIN_MEMBER_LIST = {
    ADD_USER_BUTTON: "add-user-button",
    LIST_CONTAINER: "list-container",
    LIST_ITEM: "list-item",
    LIST_ITEM_CONTEXT_MENU: "list-item-contenxt-menu",
    LIST_ITEM_STATUS: "list-item-status",
    SUCCESS_DIALOG: "success-dialog",
    ERROR_DIALOG: "error-dialog",
    MORE_MENU: "more-menu",
    MORE_MENU_SET_INACTIVE: "more-menu-set-inactive",
    MORE_MENU_SET_ACTIVE: "more-menu-set-active",
    MORE_MENU_EDIT: "more-menu-edit",
};
